// Megamenu on hover script (scoped: no top-level const collisions with app scripts)
(function () {
  var menus = document.querySelectorAll('.mega-menu');
  var closeTimers = new WeakMap();

  function cancelClose(menu) {
    var timer = closeTimers.get(menu);
    if (timer) {
      clearTimeout(timer);
      closeTimers.delete(menu);
    }
  }

  menus.forEach(function (menu) {
    // mouseenter also fires when entering the absolutely-positioned panel,
    // since it is a DOM descendant of the <details> element.
    menu.addEventListener('mouseenter', function () {
      cancelClose(menu);
      menus.forEach(function (other) {
        if (other !== menu) {
          cancelClose(other);
          other.removeAttribute('open');
        }
      });
      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function () {
      cancelClose(menu);
      closeTimers.set(
        menu,
        setTimeout(function () {
          menu.removeAttribute('open');
        }, 500)
      );
    });
  });
})();
